/* Consent-aware CRO outcomes. Customer input never enters analytics payloads. */
(function (root, factory) {
  'use strict';
  if (typeof module === 'object' && module.exports) module.exports = factory;
  else root.DSCroAnalytics = factory(root);
})(typeof window === 'object' ? window : this, function (root) {
  'use strict';
  const config = root.DS_CRO || {};
  const names = new Set(('ds_consultation_click ds_collection_gallery_consultation_click ds_collection_top_consultation_click ds_collection_product_cta_click ds_collection_product_details ds_collection_product_photo_click ds_collection_product_title_click ds_collection_browse_click ds_collection_offer_open ds_collection_video_open ds_offer_open ds_offer_ready ds_offer_started ds_offer_submitted ds_offer_accepted ds_offer_test_submitted ds_offer_test_accepted ds_offer_validation_error ds_offer_load_error ds_consultation_start ds_consultation_submit ds_consultation_sent ds_appointment_start ds_appointment_submit ds_appointment_sent ds_support_start ds_support_submit ds_support_sent ds_finder_open ds_finder_complete ds_finder_no_results ds_finder_error ds_policy_open ds_newsletter_interest ds_cart_add_success ds_options_required ds_options_complete ds_collection_filter_used ds_collection_sort_used ds_collection_no_results ds_collection_page_loaded').split(' '));
  ['ds_home_discovery_view', 'ds_home_discovery_refresh', 'ds_home_discovery_show_more', 'ds_home_discovery_filter', 'ds_home_discovery_product_click', 'ds_home_discovery_offer_click'].forEach(name => names.add(name));
  const allowed = {
    source: ['home','product','collection'],
    placement: ['product','collection'],
    reason: ['loading','required','unavailable','engraving','configuration','contact','offer','technical'],
    result_bucket: ['0','1-5','6-24','25-plus'],
    mode: ['live','test']
  };
  const memory = new Set();
  let tagsKey = '';
  const read = key => { try { return JSON.parse(root.sessionStorage.getItem(key) || 'null'); } catch { return null; } };
  const write = (key, value) => { try { root.sessionStorage.setItem(key, JSON.stringify(value)); } catch {} };
  const remove = key => { try { root.sessionStorage.removeItem(key); } catch {} };
  function permitted() { try { return root.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true; } catch { return false; } }
  function qa() {
    try {
      const value = new URLSearchParams(root.location.search).get('ds_qa');
      if (value === '1' || value === '0') write('ds-cro-qa', value === '1');
      return read('ds-cro-qa') === true;
    } catch { return false; }
  }
  function context() { return {theme_context: config.preview ? 'preview' : 'live', theme_version: String(config.version || 'cro-six-2026-09-22'), qa_session: qa() ? 'yes' : 'no'}; }
  function tag() {
    if (!permitted() || typeof root.clarity !== 'function') return;
    const values = context(), key = JSON.stringify(values);
    if (key === tagsKey) return;
    try { Object.entries(values).forEach(([name,value]) => root.clarity('set', name, value)); tagsKey = key; } catch {}
  }
  function track(name, values = {}) {
    if (!names.has(name) || !permitted()) return false;
    tag(); const payload = context();
    for (const key of Object.keys(allowed)) if (allowed[key].includes(values[key])) payload[key] = values[key];
    let sent = false;
    try { if (typeof root.clarity === 'function') { root.clarity('event',name); sent = true; } } catch {}
    try { if (typeof root.gtag === 'function') { root.gtag('event',name,payload); sent = true; } } catch {}
    return sent;
  }
  function once(key) {
    const saved = read('ds-cro-outcomes');
    const seen = Array.isArray(saved) ? saved.filter(v => typeof v === 'string').slice(-99) : [];
    if (memory.has(key) || seen.includes(key)) return false;
    memory.add(key); write('ds-cro-outcomes', [...seen,key]); return true;
  }
  // The embedding adapters MUST first verify exact origin AND the current iframe window.
  function offerMessage(data, placement) {
    if (!data || !['product','collection'].includes(placement)) return false;
    const common = {placement};
    if (data.type === 'diamond-studio-offer:started' && data.schemaVersion === 1) return track('ds_offer_started', common);
    if (data.type === 'diamond-studio-offer:validation-error' && data.schemaVersion === 1 && allowed.reason.includes(data.reason)) return track('ds_offer_validation_error', {...common,reason:data.reason});
    if (data.type !== 'diamond-studio-offer:submitted' || data.schemaVersion !== 1 || !/^[a-f0-9]{64}$/.test(data.eventId || '') || !['live','test'].includes(data.mode) || !['pending','accepted','countered','customer_countered','declined','customer_declined','expired'].includes(data.outcome)) return false;
    if (!permitted() || !once('offer:' + data.eventId)) return false;
    const prefix = data.mode === 'test' ? 'ds_offer_test_' : 'ds_offer_';
    const sent = track(prefix + 'submitted', {...common,mode:data.mode});
    if (data.outcome === 'accepted') track(prefix + 'accepted', {...common,mode:data.mode});
    return sent;
  }
  const leadKind = topic => topic === 'Order support' ? 'support' : topic === 'New York appointment' ? 'appointment' : 'consultation';
  function leadAttempt(topic) {
    if (!permitted()) { remove('ds-cro-lead-attempt'); return false; }
    const kind = leadKind(topic);
    write('ds-cro-lead-attempt', {kind,time:Date.now()});
    return track('ds_' + kind + '_submit');
  }
  // Called only when Shopify renders form.posted_successfully?. Consume before tracking.
  function leadSuccess() {
    if (!permitted()) { remove('ds-cro-lead-attempt'); return false; }
    const pending = read('ds-cro-lead-attempt');
    remove('ds-cro-lead-attempt');
    if (!pending || !['support','appointment','consultation'].includes(pending.kind) || !Number.isFinite(pending.time) || Date.now()-pending.time < 0 || Date.now()-pending.time > 7200000) return false;
    return track('ds_' + pending.kind + '_sent');
  }
  function bucket(count) { return count === 0 ? '0' : count <= 5 ? '1-5' : count <= 24 ? '6-24' : '25-plus'; }
  root.document?.addEventListener('visitorConsentCollected', tag);
  root.addEventListener?.('load', tag, {once:true});
  tag();
  return {track,tag,offerMessage,leadAttempt,leadSuccess,leadKind,bucket};
});
